export default "__VITE_PUBLIC_ASSET__7f33a592__"